import "./style.css";

import React, { Component } from "react";

import Api from "../../../../utils/Api.jsx";
import Modal from "../../Modal.jsx";
import { TwitterPicker } from "react-color";
import Cookies from "../../../../lib_react_frontend/utils/Cookies";

export default class ModalPreferenciasUsuario extends Component {
  state = {
    cor_inicial: "",
  };

  show() {
    this.setState({
      cor_inicial: this.props.empresa_selecionada.cor_principal,
    });
    this.modal.show();
  }

  hide() {
    this.modal.hide();
  }

  cancelarAlteracao() {
    this.props.dispatch({
      type: "set_empresa",
      empresa: {
        ...this.props.empresa_selecionada,
        cor_principal: this.state.cor_inicial,
      },
    });
  }

  render() {
    const botoes = [
      {
        icon: "fa-check",
        label: "Confirmar",
        className: "btn-green",
        onClick: async () => {
          await Api.salvar("salvar_cor_principal", null, { 
            cor_principal: this.state.cor_inicial, 
            id_pk: this.props.usuario.id_pk,
          });
 
          this.props.dispatch({
            type: "set_ultima_atualizacao",
            dados: {
              ...this.props.ultimaAtualizacao,
              cor_principal: this.state.cor_inicial,
            },
          });

          this.hide();
        },
      },
      {
        icon: "fa-times",
        label: "Cancelar",
        className: "btn-danger",
        dismiss: true,
        onClick: () => this.cancelarAlteracao(),
      },
    ];

    return (
      <Modal
        styleFadeModal="fadePreferencias"
        buttons={botoes}
        ref={(e) => (this.modal = e)}
        title="Preferências"
        onFecha={() => this.cancelarAlteracao()}
      >
        <div className="modalPreferencias">
          <label className="textoLabel">Cor do Sistema</label>
          <div className="linha">
            <div
              className="divCor"
              style={{
                backgroundColor: this.state.cor_inicial
                  ? this.state.cor_inicial
                  : "#fff",
              }}
            >
              <span className="textoCor">ERP B.I</span>
            </div>
            <TwitterPicker
              triangle="hide"
              color={"#EB144C"}
              colors={[
                "#B00104",
                "#760A76",
                "#FF6900",
                "#008E2C",
                "#0693E3",
                "#ABB8C3",
                "#EB144C",
                "#F88EA8",
                "#9900EF",
                "#000000",
              ]}
              onChangeComplete={(cor) => {

                this.setState({
                  cor_inicial: cor.hex,
                });

                // this.props.dispatch({
                //   type: "set_empresa",
                //   empresa: {
                //     ...this.props.empresa_selecionada,
                //     cor_principal: cor.hex,
                //   },
                // });
                // const dezAnos = new Date(
                //   new Date().getTime() + 1000 * 60 * 60 * 24 * 365 * 10
                // );
                // Cookies.set(
                //   "empresa",
                //   {
                //     ...this.props.empresa_selecionada,
                //     cor_principal: cor.hex,
                //   },
                //   dezAnos
                // );
              }}
            />
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/componentes/modais/ModalUsuarioPreferencias/index.jsx